
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface BusinessDetailErrorProps {
  error?: unknown;
}

const BusinessDetailError: React.FC<BusinessDetailErrorProps> = ({ error }) => {
  return (
    <div className="container py-16 text-center">
      <h2 className="text-2xl font-bold mb-4">Business not found</h2>
      <p className="text-muted-foreground mb-6">
        {error ? "An error occurred while loading the business." : "The business you're looking for doesn't exist."}
      </p>
      <Link to="/businesses">
        <Button>Browse All Businesses</Button>
      </Link>
    </div>
  );
};

export default BusinessDetailError;
